import isSafari from "../../../utils/isSafari";

export default () => ({
    project: null,
    playingClipId: undefined,
    relativeTime: 0,
    isPaused: true,
    isFullScreen: false,
    relativeTimeSetting: undefined,
    volume: 0.5,
    isMuted: isSafari(),
    hasEverPlayed: false,
    expandedAllClips: false,
})